import { getEnv, navigate } from '@/common/agents';
import useTeamStore, { clearTeamInfo } from '@/store/useTeamStore';
import { message } from '$/components/Message';
import { useLanguageStore } from '$/store/languageStore';

/** 被移除团队提示与首页跳转之间的等待时间。 */
const REMOVED_TEAM_REDIRECT_DELAY_MS = 3000;

/**
 * 提示成员已被移除、清理失效团队身份，并延迟返回个人首页。
 * 当前团队态同时用于去重，避免多个并发请求重复触发跳转。
 */
export function redirectRemovedTeamMemberToPersonalHome(): boolean {
  if (typeof window === 'undefined' || !useTeamStore.getState().teamInfo) {
    return false;
  }

  const removedFromTeamText = useLanguageStore.getState().languageStore.smartcatTranslationText(
    (value) => value.removed_from_team_redirecting,
  );
  message.error(removedFromTeamText, REMOVED_TEAM_REDIRECT_DELAY_MS / 1000);
  clearTeamInfo();
  // 等 Toast 完整展示后再离开当前团队页面。
  globalThis.setTimeout(() => {
    navigate({
      mode: 'url',
      url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
      replace: true,
    });
  }, REMOVED_TEAM_REDIRECT_DELAY_MS);
  return true;
}
